import { ENGLISH_IQ_RESULT_IMG_SCORES } from '../english-iq-result-img-scores';

const scoreSlugs = new Set(ENGLISH_IQ_RESULT_IMG_SCORES.map(String));

export function validateEnglishIqResultImgSlug(slug: string): boolean {
  return scoreSlugs.has(slug);
}
